<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01">Man that is born of a woman hath but a short time to live … He cometh up, and is cut down, like a flower; he fleeth as it were a shadow, and never continueth in one stay.</p>
<p class="fm-01a">Children and the fruit of the womb are an heritage and gift … Like as the arrows in the hand of the giant: even so are the young children.</p>
<p class="fm-02"><i>The Book of Common Prayer</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?05cf385f